import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {LandingPageModule} from '../../models/landing-page-module-model';

@Injectable({
  providedIn: 'root'
})
export class LandingPageModuleService {
  constructor(private readonly http: HttpClient) {
  }

  fetchLandingPageModules(): Observable<LandingPageModule[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<LandingPageModule[]>('api/config/landing-page-module', { headers });
  }
}
